import { client } from "api/client";
import * as actions from "modules/common/store/actions";
import * as endPoints from "utilities/endPoints";
import * as utility from "utilities/utils";
import commonUtilities from "utilities/common";

export default function getGroupTypes() {

    return async (dispatch) => {

        return await client.post(process.env.REACT_APP_GROUP_TYPES, endPoints.API_PARAMS.GetGroupTypesPayload()).then((response) => {

            let groupTypes = commonUtilities.buildGroupTypes(response?.data);

            return dispatch({
                type: actions.GET_GROUP_TYPES_SUCCESS,
                payload: utility.getResponse(groupTypes)
            });

        })
            .catch((error) => {

                return dispatch({
                    type: actions.GET_GROUP_TYPES_FAIL,
                    payload: utility.getErrorResponse(error)
                });

            });

    };

}
